import { Component, OnInit } from '@angular/core';
import { Ramo } from './Ramo';
import { ConfiguracionesService } from "../configuraciones/configuraciones.service";

declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let renderizarTabs: Function;
declare let convertirAMoneda: Function;
declare let mostrarToast: Function;

@Component({
  selector: 'app-configuraciones',
  templateUrl: './configuraciones.component.html'
})
export class ConfiguracionesComponent implements OnInit {

  ramoTopeSeleccionado : string;
  valorTopeSeleccionado : number;
  nuevoTope : number;
  nuevoTopeString : string;
  selectedRamo : number;
  habilitarInputTopeActual : boolean;
  arrayRamos : Ramo[];
  mostrarLoader: boolean = true;
  constructor(private configuracionService : ConfiguracionesService) { }

  ngOnInit() {
    mostrarLoader();
    renderizarTabs();
    ocultarLoader();
    this.habilitarInputTopeActual = true;
    this.arrayRamos = this.configuracionService.arrayRamos;
    this.mostrarLoader = false;
  }

  async cargarTopeRamo(){
    this.valorTopeSeleccionado = this.arrayRamos.find((ramo: Ramo) => ramo.iN_cod_ramo === this.selectedRamo).nM_ValorTope;
    this.ramoTopeSeleccionado = '$' + convertirAMoneda(this.valorTopeSeleccionado);
    console.log("selectedRamo", this.selectedRamo);
    console.log("ramoTopeSeleccionado",this.ramoTopeSeleccionado);
  }

  async validarTope(nuevoTope : string){
    this.nuevoTopeString = convertirAMoneda(this.nuevoTopeString);
  }

  async actualizarTope(){
    this.alternarLoader();
    this.nuevoTope = parseInt(this.nuevoTopeString.replace(/,/g, ""));
    let response = await this.configuracionService.actualizarTopeXRamo(this.selectedRamo,this.nuevoTope);
    let ramo = new Ramo (
      response["iN_cod_ramo"],
      response["vC_descripcionramo"],
      response["nM_ValorTope"]
    )
    this.nuevoTopeString = "";
    this.ramoTopeSeleccionado = '$' + convertirAMoneda(ramo.nM_ValorTope);
    this.alternarLoader();
    mostrarToast(`Tope del Ramo ${this.selectedRamo} actualizado a ${this.ramoTopeSeleccionado} con exito!`);
  }

  alternarLoader() {
    if (this.mostrarLoader) ocultarLoader();
    else mostrarLoader();
    this.mostrarLoader = !this.mostrarLoader;
  }

}
